import React from "react";

import Badge from "components/Badge";

import { SideLoadedBusinessRow } from "constants/sideLoadedBusinesses";

interface SideLoadedBusinessValidityRendererProps {
  data?: SideLoadedBusinessRow;
  node: { group: boolean };
}

export function SideLoadedBusinessValidityRenderer({
  data,
  node,
}: SideLoadedBusinessValidityRendererProps) {
  // A group row has no record of its own to validate.
  if (node?.group || !data) {
    return null;
  }

  const issues = data.validationIssues || [];

  if (!issues.length) {
    return <Badge color="successGreen">Valid</Badge>;
  }

  return (
    <div title={issues.join(", ")}>
      <Badge color="inputError">Invalid</Badge>
    </div>
  );
}
